var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sentiment-cyclicality-year"},[_c('SentimentMarketCombined',{attrs:{"zoom_start":"50"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }